import {
  RESEND_BAZAAR_ENQUIRY_WHATSAPP_REQUEST,
  RESEND_BAZAAR_ENQUIRY_WHATSAPP_SUCCESS,
  RESEND_BAZAAR_ENQUIRY_WHATSAPP_FAILURE,
  RESEND_BAZAAR_ENQUIRY_WHATSAPP_RESET,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
  whatsapp_status: null,
}

const resendBazaarEnquiryWhatsappReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_BAZAAR_ENQUIRY_WHATSAPP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
        whatsapp_status: null,
      }

    case RESEND_BAZAAR_ENQUIRY_WHATSAPP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message,
        whatsapp_status: action.payload.whatsapp_status,
      }

    case RESEND_BAZAAR_ENQUIRY_WHATSAPP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
      }

    case RESEND_BAZAAR_ENQUIRY_WHATSAPP_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default resendBazaarEnquiryWhatsappReducer
